module.exports = __webpack_public_path__ + "favicon-32x32.46fcd8e9.png";